import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { getStorageUrl } from "config/configUtils";
import tourImageFallback from "resources/images/tour_image_coming_soon.png";
import { store } from "WithProviders";

export const getExcursionImages = async (excursionId?: string | null) => {
  return await axios
    .get(`${getStorageUrl()}api/v1/items?itemId=${excursionId}`, {
      headers: {
        SessionId: store.getState().authentication.sessionId,
      },
    })
    .then((res) => res.data as Promise<any>);
};

type Props = {
  excursionId?: string | null;
};

export const useGetExcursionImages = ({ excursionId }: Props) => {
  const { status, data, error, isFetching, isSuccess } = useQuery({
    queryKey: ["useGetExcursionImages", excursionId],
    queryFn: () => getExcursionImages(excursionId),
    refetchOnWindowFocus: false,
    enabled: !!excursionId,
  });

  return {
    getExcursionImagesData:
      data?.map((image: any) => ({
        thumbnail: `${image?.itemPublicUrl}`,
        original: `${image?.itemPublicUrl}`,
      })) || [],
    getExcursionImageThumbnail: data?.[0]?.itemPublicUrl ?? tourImageFallback,
    getExcursionImagesStatus: status,
    getExcursionImagesError: error,
    getExcursionImagesIsFething: isFetching,
    getExcursionImagesIsSuccess: isSuccess,
  };
};
